import { render, staticRenderFns } from "./PlatformCampaignReportV2.vue?vue&type=template&id=87dcba24"
import script from "./PlatformCampaignReportV2.vue?vue&type=script&lang=js"
export * from "./PlatformCampaignReportV2.vue?vue&type=script&lang=js"
import style0 from "./PlatformCampaignReportV2.vue?vue&type=style&index=0&id=87dcba24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports